import { render, staticRenderFns } from "./BicCodes.vue?vue&type=template&id=79428f06"
import script from "./BicCodes.vue?vue&type=script&lang=js"
export * from "./BicCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports